import {
	LeadEventApiDto,
	LeadQuoteFinanceProductChangedEventDataApiDto,
} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import moment = require("moment");

export default class LeadQuoteFinanceProductChangedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} createdAt creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param {LeadQuoteFinanceProductChangedEventData} data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly createdAt: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadQuoteFinanceProductChangedEventData) {
		super(id, leadId, type, entity, createdAt, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadQuoteFinanceProductChangedEvent {
		const data = LeadQuoteFinanceProductChangedEventData.fromJson(json.data as LeadQuoteFinanceProductChangedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadQuoteFinanceProductChangedEvent(
			json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteFinanceProductChanged,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data
		);
	}

	getActivityType(): string {
		return `QUOTE ${this.data.quoteNumber}`
	}

	getActivityMessage(): string {
		if (this.data.financeProductLabel) {
			return `Quote finance product changed to ${this.data.financeProductLabel}`;
		}
		return `Quote finance product has been removed`;
	}
}

export class LeadQuoteFinanceProductChangedEventData {
	constructor(public readonly quoteNumber: string,
		public readonly quoteId: string,
		public readonly financeProductId: string,
		public readonly financeProductLabel: string,
	) {}

	public static fromJson(json: LeadQuoteFinanceProductChangedEventDataApiDto): LeadQuoteFinanceProductChangedEventData {
		return new LeadQuoteFinanceProductChangedEventData(
			json.quoteNumber,
			json.quoteId,
			json.financeProductId,
			json.financeProductLabel
		);
	}
}
